import { DomainError } from './DomainError';

/**
 * Network error
 * Thrown when HTTP requests fail due to network issues
 */
export class NetworkError extends DomainError {
  constructor(
    message: string,
    public readonly statusCode?: number,
    public readonly originalError?: unknown,
  ) {
    super(message);
  }

  static requestFailed(error: unknown): NetworkError {
    return new NetworkError('Request failed', undefined, error);
  }

  static serverError(statusCode: number, message?: string): NetworkError {
    return new NetworkError(message || 'Server error occurred', statusCode);
  }

  static timeout(): NetworkError {
    return new NetworkError('Request timeout');
  }

  static networkUnavailable(): NetworkError {
    return new NetworkError('Network is unavailable');
  }
}
